import {requestWithToken} from "./request";

// 获取消费类型列表
export function getCostTypeList() {
  return requestWithToken({
    url: '/api/account/costType',
    method: 'get'
  })
}

// 获取资金来源信息
export function getCapitalSource() {
  return requestWithToken({
    url: '/api/account/capital',
    method: 'get'
  })
}

// 获取消费记录信息
export function getCostRecord(data) {
  return requestWithToken({
    url: '/api/account/costRecord/pageQuery',
    method: 'post',
    data: data
  })
}

// 新增消费记录
export function addCostRecord(data) {
  return requestWithToken({
    url: '/api/account/costRecord/add',
    method: 'post',
    data: data
  })
}

// 修改消费记录
export function updateCostRecord(data) {
  return requestWithToken({
    url: '/api/account/costRecord/update',
    method: 'post',
    data: data
  })
}

// 删除消费记录
export function deleteCostRecord(id) {
  return requestWithToken({
    url: '/api/account/costRecord/delete/' + id,
    method: 'put'
  })
}

// 获取消费统计信息
export function queryTotalCost(type) {
  return requestWithToken({
    url: '/api/account/costRecord/queryTotal/' + type,
    method: 'get',
  })
}

// 获取最近6月账期的消费情况
export function queryRecentAccountPeriodCost() {
  return requestWithToken({
    url: '/api/account/costRecord/recentMonthsCostTotal',
    method: 'get',
  })
}

// 获取今日消费情况
export function queryTodayCostRecords() {
  return requestWithToken({
    url: '/api/account/costRecord/getTodayCost',
    method: 'get',
  })
}

// 获取进30天消费情况
export function queryRecent30DaysCost() {
  return requestWithToken({
    url: '/api/account/costRecord/getRecent30DaysCost',
    method: 'get'
  })
}

// 当前周期消费信息
export function queryCurrentPeriodByCostTypeIds(costTypeId) {
  return requestWithToken({
    url: '/api/account/costRecord/queryCurrentPeriodCost/' + costTypeId,
    method: 'get'
  })
}

// 查询指定周期消费信息
export function queryPeriodByCostTypeAndMonthStr(data){
  return requestWithToken({
    url: '/api/account/costRecord/queryPeriodCost',
    method: 'post',
    data: data
  })
}

// 首页
export function queryHomePage(monthStr) {
  return requestWithToken({
    url: '/api/account/homePage',
    method: 'get',
    params: {
      monthStr
    }
  })
}

// 根据消费日期查询指定日期的消费情况
export function queryCostByDate(date) {
  return requestWithToken({
    url: '/api/account/costRecord/queryCostByDate/' + date,
    method: 'get'
  })
}

// 根据消费日期查询指定日期的消费情况
export function queryCostByMonth(date) {
  return requestWithToken({
    url: '/api/account/homePage/getPointMonthCost',
    method: 'get',
    params: {
      localDate: date
    }
  })
}
